import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { green } from "@mui/material/colors";

const EditTableDialog = ({
  open,
  onClose,
  table,
  onEdit,
  loading,
  handleDeleteTable,
}) => {
  const [arrangementName, setArrangementName] = useState(
    table.arrangement_name
  );
  const [side, setSide] = useState(table.side);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleEdit = () => {
    onEdit({ arrangement_name: arrangementName, side });
  };

  const onDeleteTable = async () => {
    handleDeleteTable(table.id);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack direction="row" justifyContent="space-between">
        <DialogTitle>テーブルを編集</DialogTitle>
        {isSmallScreen ? (
          <IconButton style={{ margin: "0 12px 0 0" }}>
            <DeleteIcon onClick={() => setOpenDeleteDialog(true)} />
          </IconButton>
        ) : (
          <Button
            style={{ margin: "0 12px 0 0" }}
            onClick={() => setOpenDeleteDialog(true)}
          >
            このテーブルを削除
          </Button>
        )}
      </Stack>

      <DialogContent>
        {/* <Box sx={{ width: '100%' }}>
                        <Collapse in={openAlert}>
                            <Alert
                                severity="error"
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={() => {
                                            setOpenAlert(false);
                                        }}
                                    >
                                        <CloseIcon fontSize="inherit" />
                                    </IconButton>
                                }
                                sx={{ mb: 2 }}
                            >
                                {errorMessage}
                            </Alert>
                        </Collapse>
                    </Box> */}

        <TextField
          autoFocus
          margin="dense"
          label="テーブル名"
          fullWidth
          value={arrangementName}
          onChange={(e) => setArrangementName(e.target.value)}
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="side-select-label">サイド</InputLabel>
          <Select
            labelId="side-select-label"
            label="サイド"
            value={side}
            onChange={(e) => setSide(e.target.value)}
          >
            <MenuItem value="bride">新婦</MenuItem>
            <MenuItem value="groom">新郎</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
          <Button variant="contained" onClick={onClose} color="secondary">
            キャンセル
          </Button>
          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={handleEdit}
              disabled={loading}
              color="primary"
            >
              保存
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Stack>
      </DialogActions>

      {/* 削除確認ダイアログ */}
      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>削除確認</DialogTitle>
        <DialogContent>
          <Typography>このテーブルを削除しますか？</Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
            <Button
              variant="contained"
              onClick={() => setOpenDeleteDialog(false)}
              color="secondary"
            >
              キャンセル
            </Button>
            <Box sx={{ position: "relative" }}>
              <Button
                variant="contained"
                onClick={onDeleteTable}
                disabled={loading}
                color="primary"
              >
                削除
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </Stack>

          {/* <Button onClick={() => setOpenDeleteDialog(false)} color="secondary">キャンセル</Button>
                    <Button onClick={handleDelete} color="primary">削除</Button> */}
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default EditTableDialog;
